module.exports = __webpack_public_path__ + "static/media/empty_card.7d490222.png";